// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___ck92","label":"styles_label__3Jnp_"};